Namespace 'CustomerVisualMode'

class CustomerVisualMode.NullValueTranslator
  translate: (dataItem) ->
    dataItem.value
